import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxCurrencyModule } from 'ngx-currency';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CustomCurrencyMaskConfig } from '@core/core.module';
import { CoreModule } from '@core/core.module';
import { COMPONENTS } from './_componentes';
import { ImageCropperModule } from 'ngx-image-cropper';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { InstructorCfcAutocompleteComponent } from './inputs/instructor-cfc-autocomplete/instructor-cfc-autocomplete.component';
import { LocalAtendimentoDetranAutocompleteComponent } from './inputs/local-atendimento-detran-autocomplete/local-atendimento-detran-autocomplete.component';

@NgModule({
    declarations: [
        COMPONENTS,
        InstructorCfcAutocompleteComponent,
        LocalAtendimentoDetranAutocompleteComponent,
    ],
    exports: [
        COMPONENTS
    ],
    imports: [
        CommonModule,
        CarouselModule,
        CoreModule,
        FormsModule,
        NgxCurrencyModule.forRoot(CustomCurrencyMaskConfig),
        ImageCropperModule,
        RouterModule,
    ]
})
export class ComponentsModule { }
